export type PositionType = 'none' | 'full' | 'bottom';

type Positions = {
  [key in PositionType]: key;
};

export const POSITIONS: Positions = {
  none: 'none',
  full: 'full',
  bottom: 'bottom',
};

export interface BorderPosition {
  value: PositionType;
  illustration: React.ReactElement;
  label: string;
  dataHook: string;
}

export const stripsAndColumnsIllustrationNames = {
  [POSITIONS.none]: 'thumb-strip-border-none',
  [POSITIONS.full]: 'thumb-strip-border-all-sides',
  [POSITIONS.bottom]: 'thumb-strip-border-bottom',
};

export const regularIllustrationNames = {
  [POSITIONS.none]: 'bp-no-border',
  [POSITIONS.full]: 'bp-all-sides-border',
  [POSITIONS.bottom]: 'bp-single-bottom-border',
};
